import { Injectable } from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';

const ENV_VARIABLES = '/assets/json/env_variables.json';

@Injectable()
export class ConfigService {

  /*
    These URL's default to the devopment environment. There should be an env_variables.json
    file in assets/json with the appropriate values - these defaults should ideally not be used.
    Loading in of these variables will occur in the customHttp service.
    */
  public HELPDESK_API_URL = 'https://prodapi.parrotanalytics.com/helpdesk';
  public ES_SERVICE = 'es-pa-apps';
  public DATA_API_URL = 'https://prodapi.parrotanalytics.com/demand/v1/';
  public CATALOG_API_URL = 'https://prodapi.parrotanalytics.com/catalog/v1/v1/';
  public SAMPLE_YOUTUBE_API_KEY = 'AIzaSyC13cLIXs1C826rwdBhr_NwryH9Vv817Cw';
  //graphql api key
  public GENOME_API_KEY = '545b77e7-ec6a-fc9a-e1d4-7fe2d655495c';

  envVars: any = {};
  // Constants from Catalog API
  public CATALOG_CONSTANTS = this.CATALOG_API_URL + 'constants';
  public ALL_ACCOUNTS = this.DATA_API_URL + '/account?account_type=subscription';
  public GENRES;
  public GENRE_TAGS;
  public OCCUPATION_TAGS;
  public GENDER;
  public TV_STATUS;
  public VERIFICATION_STATUS;
  public TV_SERIES_TYPE;
  public SPORTS_CONTENT_SUB_TYPE;
  public SPORTS_ENVIRONMENT;
  public SPORTS_PARTICIPATION;
  public SPORTS_GAME_TYPE;
  public SPORTS_SKILL_SET;
  public SPORTS_EVENT_FREQUENCY;
  public SPORTS_GAME;
  public MOVIE_STATUS;
  public COUNTRIES;
  public LANGUAGES;
  public NETWORKS;
  public CONTENT_TYPES;
  public CONTENT_SUB_TYPES;
  public YOUTUBE_API_KEYS;


  constructor(private http: Http) {
  }

  async loadEnvVariables() {
    try {
      const vars = await this.http.get(ENV_VARIABLES).map(res => res.json()).toPromise();
      this.envVars = vars;
      this.HELPDESK_API_URL = this.envVars['HELPDESK_API_URL'] || this.HELPDESK_API_URL;
      this.DATA_API_URL = this.envVars['DATA_API_URL'] || this.DATA_API_URL;
      this.CATALOG_API_URL = this.envVars['CATALOG_API_URL'] || this.CATALOG_API_URL;
      this.GENOME_API_KEY = this.envVars['GENOME_API_KEY'] || this.GENOME_API_KEY;
      this.YOUTUBE_API_KEYS = (this.envVars['YOUTUBE_API_KEYS'] || this.SAMPLE_YOUTUBE_API_KEY).split(',');
      this.YOUTUBE_API_KEYS = (this.envVars['YOUTUBE_API_KEYS'] || this.SAMPLE_YOUTUBE_API_KEY).split(',');
      this.ES_SERVICE = this.envVars['ES_SERVICE'] || this.HELPDESK_API_URL;
      this.CATALOG_CONSTANTS = this.CATALOG_API_URL + 'constants';
    } catch (err) {
      this.envVars = [];
      this.YOUTUBE_API_KEYS = [this.SAMPLE_YOUTUBE_API_KEY];
      console.error('env_variables.json not found.Using default environment variables');
    }
    return this.envVars;
  }

  fetchGenderTags() {


    const myHeaders = new Headers();
    myHeaders.append('x-api-key', this.GENOME_API_KEY);
    myHeaders.append('Content-Type', 'application/json');

    const graphqlQuery = JSON.stringify({
      query: 'query MyQuery {\n  talentGenders{\n    items\n    total\n  }\n}\n',
      variables: {}
    });
    // const requestOptions = {
    //   method: 'POST',
    //   headers: myHeaders,
    //   body: graphql,
    //   redirect: 'follow'
    // };
    const options = new RequestOptions({ headers: myHeaders });
    const graphqlURL = 'https://prodapi.parrotanalytics.com/graphql/v1';

    return this.http.post(graphqlURL, graphqlQuery, options)
        .map(res => res.json())
        .toPromise()
        .catch(error => console.log(error));

  }

  async loadCatalogConstants() {
    try {
      const result = await this.http.get(`${this.CATALOG_CONSTANTS}?type=all`).map(res => res.json()).toPromise();
      this.GENRES = result.genres || {};
      this.GENRE_TAGS = result.genreTags || [];
      this.OCCUPATION_TAGS = result.occupationTags || [];
      this.TV_STATUS = result.tvStatus || ['In Production', 'Upcoming', 'Current', 'Returning', 'Ended'];
      this.VERIFICATION_STATUS = result.verificationStatus || ['SYSTEM_VERIFIED', 'HUMAN_VERIFIED'];
      this.TV_SERIES_TYPE = ['scripted', 'unscripted'];
      this.SPORTS_CONTENT_SUB_TYPE = ['Competition', 'Sports Team', 'Event'];

      this.SPORTS_ENVIRONMENT = ['Outdoor', 'Indoor'];
      this.SPORTS_PARTICIPATION = ['Individual Game', 'Individual | Team', 'Team Game'];
      this.SPORTS_GAME_TYPE = ['Ball Sport', 'Combat Sport', 'Cycling', 'Motor Sport', 'Shuttle Sport', 'Video Game', 'Water Sport'];
      this.SPORTS_SKILL_SET = ['ENDURANCE', 'MIXED', 'SKILL'];
      this.SPORTS_EVENT_FREQUENCY = ['Every 2 Years', 'Every 4 Years', 'Yearly'];

      this.SPORTS_GAME = ['8BALL', 'AMERICAN FOOTBALL', 'ATHLETICS', 'BADMINTON', 'BASEBALL', 'BASKETBALL', 'BILLIARDS', 'BOXING', 'CRICKET', 'CYCLING', 'E-SPORTS', 'FOOTBALL', 'GOLF', 'HOCKEY', 'MMA', 'NASCAR', 'PADEL', 'PICKLEBALL', 'POOL', 'RACING', 'RUGBY', 'RUGBY LEAGUE.', 'SAILING', 'SQUASH', 'TABLE TENNIS', 'TENNIS', 'VOLLEYBALL'];
      this.MOVIE_STATUS = result.MovieStatus || ['In_Production', 'Upcoming', 'Current'];
      const response = await this.fetchGenderTags();
      const genderTags = response.data.talentGenders.items;
      this.GENDER = genderTags ||  [];
      this.COUNTRIES = result.countries || [];
      this.LANGUAGES = result.languages || [];
      this.NETWORKS = result.networks || [];
      this.CONTENT_TYPES = result.contentTypes || [];
      this.CONTENT_SUB_TYPES = result.contentSubTypes || [];
    } catch (err) {
      console.error('failed to load constants from catalog api');
      this.GENRES = {};
      this.GENRE_TAGS = [];
      this.COUNTRIES = [];
      this.LANGUAGES = [];
      this.NETWORKS = [];
      this.CONTENT_TYPES = [];
      this.CONTENT_SUB_TYPES = [];
    }
    return {};
  }

  getYoutubeApiKey() {
    if (this.YOUTUBE_API_KEYS.length > 1) {
      return this.YOUTUBE_API_KEYS[Math.floor(Math.random() * this.YOUTUBE_API_KEYS.length)];
    }
    return this.YOUTUBE_API_KEYS[0];
  }

  async load() {

    await this.loadEnvVariables();

    return await this.loadCatalogConstants();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/config.service.ts